import { atom, useRecoilValue } from 'recoil'
export type LoadingStoreType = {
    isLoading: boolean
}
export const loadingStore = atom<LoadingStoreType>({
    key: 'loadingStore',
    default: {
        isLoading: false,
    },
})

const useLoadingStore = () => {
    const loadingState = useRecoilValue(loadingStore)
    return {
        ...loadingState,
    }
}

export default useLoadingStore
